<template>
  <div class="inventory-report-page">
    <div class="inquire-module" id="page-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-range-picker :disabled-date="disabledDate" :disabled-time="disabledRangeTime" format="YYYY-MM-DD"
            v-model="dateValue" @change="changeData" />
        </a-col>
        <a-col :md="20" :sm="6" class="button-add-col">
          <a-button icon="printer" type="primary border-arc" v-has="'statistical_balance_report_print'" @click="btnPrint">打印</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="inventory-report-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
        :scroll="{ y: (tableHeight) }" bordered>
      </a-table>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
    <preview-print ref="printPreview"></preview-print>
  </div>
</template>
<script>
import moment from "moment";
import pick from "lodash.pick";
import { getInventoryList } from "@/utils/api";
import previewPrint from '@/components/print/previewPrint.vue'
export default {
  name: "inventoryReport",
  components: {
    previewPrint,
  },
  data() {
    return {
      columns: [
        {
          title: "日期",
          dataIndex: "date",
        },
        {
          title: "库存金额",
          dataIndex: "stockAmount",
        },
        {
          title: "库存数量",
          dataIndex: "stockCount",
        },
      ],
      dataSource: [],
      formData: {},
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 100,
      },
      tableHeight: "",
      contentHeight: "",
    };
  },
  activated() {
    // 表格高度计算
    let _that = this
    setTimeout(function() {
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
    }, 50)
    this.getList();
  },
  methods: {
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },

    disabledRangeTime(_, type) {
      if (type === "start") {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },
    // 选择筛选日期
    changeData(date, dateString) {
      this.formData.startTime = dateString[0];
      this.formData.endTime = dateString[1];
      this.getList();
    },
    // 页面变化时回调
    onChangeIpagination(current) {
      this.ipagination.current = current;
      this.getList();
    },
    // 一页显示条数变化时回调
    onShowSizeChange(current, pageSize) {
      this.ipagination.current = current;
      this.ipagination.pageSize = pageSize;
      this.getList();
    },
    // 打印弹框
    btnPrint() {
      this.$refs.printPreview.open({
        templateType: 501,
        total:this.ipagination.total,
        endTime: this.formData.endTime,
        startTime: this.formData.startTime,
      })
    },
    getList() {
      let params = {
        companyId: this.$store.state.userInfo.companyId,
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        endTime: this.formData.endTime,
        startTime: this.formData.startTime,
      };
      let data = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      this.$store.state.isLoding = true;
      getInventoryList(params, {}, data).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result.records;
          this.ipagination.total = parseInt(res.result.total);
          this.$store.state.isLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.inventory-report-page {
  .inquire-module {
    height: 80px;
    padding: 0 25px;
    background-color: #ffffff;
    .ant-row {
      height: 80px !important;
      display: flex;
      align-items: center;
    }
    .ant-calendar-picker {
      width: 100%;
    }
    .button-add-col {
      display: flex;
      justify-content: flex-end;
      .ant-btn {
        font-size: 16px;
        margin-left: 16px;
      }
    }
    .ant-form-item {
      margin-bottom: 0 !important;
    }
  }
  .inventory-report-table {
    margin-top: 16px;
    background: #ffffff;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }

  .pagination-box {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>
